import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, Provider, ReactReduxContext } from 'react-redux';
import { createPlanItem, editSubscribedBoost, getSubscribedPostCount, planAdFromPastPlannedAd } from 'redux/modules/adsPlanner';
import * as _ from 'lodash';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import AddCircle from 'material-ui/svg-icons/content/add-circle';
import { AdTypeIcon, PlanTableHeader, PlanTableRow, PlanTableSection, SubscribedPostPlanTableRow } from 'components';
import PlannedAdWrap from './PlannedAdWrap';
import * as styles from './AdsPlanStep1.scss';
var AdsPlanStep1 = (_dec = connect(function (state, props) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    subscribedPostCount: state.adsPlanner && state.adsPlanner[orgId] ? state.adsPlanner[orgId].subscribedPostCount : {
      numSubscribedPosts: 0,
      numSubscribedBoostablePosts: 0
    },
    currentPlanId: state.adsPlanner && state.adsPlanner[orgId] ? state.adsPlanner[orgId].currentPlanId : 1
  };
}, {
  createPlanItem: createPlanItem,
  editSubscribedBoost: editSubscribedBoost,
  getSubscribedPostCount: getSubscribedPostCount,
  planAdFromPastPlannedAd: planAdFromPastPlannedAd
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AdsPlanStep1, _Component);

  var _super = _createSuper(AdsPlanStep1);

  function AdsPlanStep1(props) {
    var _this;

    _classCallCheck(this, AdsPlanStep1);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "calculatePlannedAdsTotal", function (adsPlan) {
      return adsPlan.AdsPlannerCategories.reduce(function (accumulator, cat) {
        return accumulator + parseInt(cat.budget);
      }, 0);
    });

    _defineProperty(_assertThisInitialized(_this), "handleEditSubscribedRow", function (numPosts, budgetPerPost) {
      var budgetPerPostInCents = budgetPerPost * 100;

      _this.props.editSubscribedBoost(_this.props.organization.id, _this.props.currentPlanId, numPosts, budgetPerPostInCents);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDeleteSubscribedRow", function () {
      _this.props.editSubscribedBoost(_this.props.organization.id, _this.props.currentPlanId, 0, '0');
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddSubscribedRow", function () {
      _this.props.editSubscribedBoost(_this.props.organization.id, _this.props.currentPlanId, _this.props.subscribedPostCount.numSubscribedBoostablePosts, '200');
    });

    _defineProperty(_assertThisInitialized(_this), "renderBrowseMenu", function (cat) {
      return /*#__PURE__*/React.createElement(IconMenu, {
        iconButtonElement: /*#__PURE__*/React.createElement(IconButton, {
          iconStyle: {
            height: 19,
            width: 19
          },
          style: {
            height: 20,
            padding: 0
          }
        }, /*#__PURE__*/React.createElement(AddCircle, null))
      }, /*#__PURE__*/React.createElement(MenuItem, {
        primaryText: "Plan New Ad",
        onClick: function onClick() {
          _this.props.handleNewAdBtnClick(cat.id);
        }
      }), /*#__PURE__*/React.createElement(MenuItem, {
        primaryText: "Browse Used Ads",
        onClick: function onClick() {
          _this.setState({
            showPlannedAdsModal: true,
            currentModalCategory: cat.type,
            currentModalCategoryId: cat.id
          });
        }
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderSubscribedSection", function (cat, subscribedPostCount) {
      var boostInfo = cat.SubscribedPostBoost;
      var budgetPerPost = boostInfo && boostInfo.budgetPerPost ? boostInfo.budgetPerPost : 0;
      var countOfPosts = boostInfo && boostInfo.countOfPosts ? boostInfo.countOfPosts : 0;
      var rowActive = !!(countOfPosts || parseInt(budgetPerPost) || parseInt(cat.budget));
      var ad = {
        budget: budgetPerPost,
        numPosts: countOfPosts
      };
      var leftContent = /*#__PURE__*/React.createElement("span", {
        className: styles.leftContentWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.leftContentItem
      }, "Total: ", _this.props.formatCurrency(cat.budget)), /*#__PURE__*/React.createElement("span", {
        className: styles.leftContentItem
      }, countOfPosts, " ", countOfPosts !== 1 ? ' Posts' : ' Post', !rowActive && /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center',
          width: 48
        }
      }, /*#__PURE__*/React.createElement(AddCircle, {
        style: {
          cursor: 'pointer',
          height: 19,
          width: 19
        },
        onClick: function onClick() {
          _this.handleAddSubscribedRow();
        }
      }))));
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PlanTableHeader, {
        icon: /*#__PURE__*/React.createElement(AdTypeIcon, {
          adType: "SUBSCRIBED_POSTS",
          source: "adsPlanner"
        }),
        title: "Boosts - Subscribed Posts",
        leftContent: leftContent
      }), rowActive && /*#__PURE__*/React.createElement(SubscribedPostPlanTableRow, {
        ad: ad,
        editable: true,
        handleEditPlanItem: _this.handleEditSubscribedRow,
        handleDeletePlanItem: _this.handleDeleteSubscribedRow,
        formatCurrency: _this.props.formatCurrency
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 16,
          marginLeft: 152
        }
      }, "".concat(subscribedPostCount.numSubscribedBoostablePosts, " of ").concat(subscribedPostCount.numSubscribedPosts, " Subscribed posts are boostable")));
    });

    _this.state = {
      showPlannedAdsModal: false,
      currentModalCategory: '',
      currentModalCategoryId: 0,
      selectedPreviousPlannedAdId: -1
    };
    return _this;
  }

  _createClass(AdsPlanStep1, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.getSubscribedPostCount(this.props.organization.id);
    }
    /** *********************************************************
     CUSTOM METHODS
     ***********************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          adsPlan = _this$props.adsPlan,
          subscribedPostCount = _this$props.subscribedPostCount;
      var plannedAdsTotal = this.calculatePlannedAdsTotal(adsPlan);
      var colorClass = parseInt(adsPlan.budget) === plannedAdsTotal ? 'green' : 'red';
      var cats = adsPlan.AdsPlannerCategories.sort(function (a, b) {
        if (a.type < b.type) return -1;
        if (a.type > b.type) return 1;
        return 0;
      });
      var postCats = cats.filter(function (cat) {
        return cat.type === 'CUSTOM_POSTS' || cat.type === 'SUBSCRIBED_POSTS';
      });
      var adCats = cats.filter(function (cat) {
        return cat.type !== 'CUSTOM_POSTS' && cat.type !== 'SUBSCRIBED_POSTS';
      });
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.pastMonth ? styles.pastMonth : ''
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.step1Wrap
      }, adCats.map(function (category, index) {
        return /*#__PURE__*/React.createElement(PlanTableSection, {
          key: index,
          category: category,
          handleNewAdBtnClick: _this2.props.handleNewAdBtnClick,
          handleDeletePlanItem: _this2.props.handleDeletePlanItem,
          handleEditPlanItem: _this2.props.handleEditPlanItem,
          formatCurrency: _this2.props.formatCurrency,
          addBtnMenu: _this2.renderBrowseMenu(category),
          pastMonth: _this2.props.pastMonth
        });
      }), !this.props.pastMonth && /*#__PURE__*/React.createElement(PlanTableSection, {
        handleNewAdBtnClick: this.props.handleNewAdBtnClick,
        handleDeletePlanItem: this.props.handleDeletePlanItem,
        handleEditPlanItem: this.props.handleEditPlanItem,
        category: postCats[0],
        formatCurrency: this.props.formatCurrency
      }), !!postCats && !this.props.pastMonth && postCats.length > 1 && !!subscribedPostCount && this.renderSubscribedSection(postCats[1], subscribedPostCount)), /*#__PURE__*/React.createElement("div", {
        className: styles.bottomWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.planTotal
      }, "Plan Total:", ' ', /*#__PURE__*/React.createElement("span", {
        className: styles[colorClass]
      }, "".concat(this.props.formatCurrency(plannedAdsTotal), " of ").concat(this.props.formatCurrency(adsPlan.budget)))), !adsPlan.isApproved && /*#__PURE__*/React.createElement(RaisedButton, {
        disabled: this.calculatePlannedAdsTotal(adsPlan) === 0 || adsPlan.isApprovingPlan,
        secondary: true,
        label: adsPlan.isApprovingPlan ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spin fa-spinner",
          style: {
            fontSize: 20
          }
        }) : 'Approve Plan',
        onClick: function onClick() {
          _this2.props.handleApproveAdsPlan(adsPlan.id);
        }
      })), /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(Dialog, {
          title: "Select An Ad To Duplicate",
          open: _this2.state.showPlannedAdsModal,
          contentStyle: {
            width: '85%',
            maxWidth: 100000
          },
          modal: true,
          onRequestClose: function onRequestClose() {
            _this2.setState({
              showPlannedAdsModal: false,
              currentModalCategory: '',
              currentModalCategoryId: 9999
            });
          },
          actions: [/*#__PURE__*/React.createElement(RaisedButton, {
            label: "Close",
            onClick: function onClick() {
              _this2.setState({
                showPlannedAdsModal: false,
                currentModalCategory: '',
                currentModalCategoryId: 9999
              });
            },
            style: {
              marginRight: 24
            }
          }), /*#__PURE__*/React.createElement(RaisedButton, {
            secondary: true,
            label: "Duplicate",
            disabled: _this2.state.selectedPreviousPlannedAdId === -1,
            onClick: function onClick() {
              _this2.props.createPlanItem(_this2.props.organization.id, _this2.state.currentModalCategoryId).then(function (res) {
                var currentAdId = res.data.createdAd.id;

                _this2.props.planAdFromPastPlannedAd(_this2.props.organization.id, adsPlan.id, currentAdId, _this2.state.selectedPreviousPlannedAdId).then(function () {
                  _this2.setState({
                    showPlannedAdsModal: false,
                    currentModalCategory: '',
                    currentModalCategoryId: 0,
                    selectedPreviousPlannedAdId: -1
                  });
                });
              });
            }
          })]
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(PlannedAdWrap, {
          category: _this2.state.currentModalCategory,
          selectedAdId: _this2.state.selectedPreviousPlannedAdId,
          handleAdCardClick: function handleAdCardClick(adId) {
            _this2.setState({
              selectedPreviousPlannedAdId: adId
            });
          }
        })));
      }));
    }
  }]);

  return AdsPlanStep1;
}(Component)) || _class);
export { AdsPlanStep1 as default };